export const CORRELATION_ID_HEADER = "X-Correlation-Id"
